module.exports = __webpack_public_path__ + "static/media/close-black.69f6e463.svg";